import { Component, OnInit } from '@angular/core';
import {ResetPassword} from "../models/usermaster";
import {FormGroup, FormControl, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {UsermasterService} from "../services/usermaster.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-resetpasswordview',
  templateUrl: './resetpassword.component.html',
})
export class ResetPasswordComponent implements OnInit {
    resetpasswordForm;

    private router: Router;
    resetpassword:ResetPassword;
    constructor(
        private resetpasswordService:UsermasterService,
        private activatedRoute: ActivatedRoute
    ) { }

    createResetPasswordForm(){
        this.resetpasswordForm = new FormGroup({
          authcode: new FormControl("",[
            Validators.required,
          ]),
          password: new FormControl("",[
            Validators.required,
            Validators.minLength(3)
          ]),
          confirmpassword: new FormControl("",[
            Validators.required,
            Validators.minLength(3)
          ])
        });
    }
    
    ngOnInit() {
        this.createResetPasswordForm();
        this.activatedRoute.params.subscribe(params => {
            console.log("Acode==>>"+params['authcode']);
            this.resetpasswordForm.patchValue({
                authcode: params['authcode'],
            })
        });
    }

    onSubmit(resetpasswordValue) {
        this.resetpasswordService.resetpasswordCall(resetpasswordValue.authcode,resetpasswordValue.password,resetpasswordValue.confirmpassword).then(UserData => {
          console.log('======RESPONE GET======');
          if(UserData['code'] === 200){
            alert(UserData['message'])
            console.log(UserData['message']);
            console.log(UserData['data']);
            this.router.navigate(['/home']);
          }else{
            alert(UserData['message'])
            console.log(UserData['message']);
          }
        }).catch(err => {
          console.log( 'err============>', err );
        });
    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/usermaster/resetpassword/resetpassword.component.ts